module.exports = __webpack_public_path__ + "img/tennis.dacb32e7.jpg";